var updateEncodedCookie = function updateEncodedCookie(_ref) {
  var cookie = _ref.cookie,
    index = _ref.index,
    value = _ref.value;
  var cookieObject = cookie;
  cookieObject[index] = value;
  return cookieObject;
};
export default updateEncodedCookie;